if (!customElements.get('description-read-more')) {
  class DescriptionReadMore extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.descriptionEl = this.querySelector('.product__description--truncated');
      this.toggleBtn = this.querySelector('.product-description-read-more__button');
      if (!this.descriptionEl || !this.toggleBtn) return;
      this._collapsedHeight = this._measureCollapsedHeight();
      this.descriptionEl.style.maxHeight = this._collapsedHeight + 'px';
      this.checkOverflow();
      this.toggleBtn.addEventListener('click', this.handleToggle);
      this._resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this._resizeObserver.observe(this.descriptionEl);
    }

    disconnectedCallback() {
      this.toggleBtn?.removeEventListener('click', this.handleToggle);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    _measureCollapsedHeight() {
      this.descriptionEl.style.webkitLineClamp = '5';
      this.descriptionEl.style.display = '-webkit-box';
      this.descriptionEl.style.webkitBoxOrient = 'vertical';
      this.descriptionEl.style.overflow = 'hidden';
      const height = this.descriptionEl.offsetHeight;
      this.descriptionEl.style.webkitLineClamp = '';
      this.descriptionEl.style.display = '';
      this.descriptionEl.style.webkitBoxOrient = '';
      this.descriptionEl.style.overflow = '';
      return height;
    }

    handleToggle() {
      const expanded = this.toggleBtn.getAttribute('aria-expanded') === 'true';
      this.toggleBtn.setAttribute('aria-expanded', String(!expanded));
      this.toggleBtn.textContent = !expanded
        ? this.toggleBtn.dataset.readLess
        : this.toggleBtn.dataset.readMore;

      if (!expanded) {
        this.descriptionEl.classList.add('is-expanded');
        this.descriptionEl.style.maxHeight = this.descriptionEl.scrollHeight + 'px';
        this.descriptionEl.addEventListener(
          'transitionend',
          () => {
            this.descriptionEl.style.maxHeight = '';
            this.descriptionEl.style.overflow = '';
          },
          { once: true }
        );
      } else {
        if (!this.descriptionEl.style.maxHeight || this.descriptionEl.style.maxHeight === 'none') {
          this.descriptionEl.style.overflow = 'hidden';
          this.descriptionEl.style.maxHeight = this.descriptionEl.scrollHeight + 'px';
        }
        requestAnimationFrame(() => {
          this.descriptionEl.style.overflow = 'hidden';
          this.descriptionEl.style.maxHeight = this._collapsedHeight + 'px';
        });
        this.descriptionEl.classList.remove('is-expanded');
      }
    }

    checkOverflow() {
      const isExpanded = this.descriptionEl.classList.contains('is-expanded');
      if (!isExpanded) {
        this._collapsedHeight = this._measureCollapsedHeight();
        this.descriptionEl.style.maxHeight = this._collapsedHeight + 'px';
        this.descriptionEl.style.overflow = 'hidden';
      }
      const hasOverflow = isExpanded || this.descriptionEl.scrollHeight > this._collapsedHeight;
      this.toggleBtn.style.display = hasOverflow ? '' : 'none';
    }
  }

  customElements.define('description-read-more', DescriptionReadMore);
}
